/* eslint-disable react-hooks/exhaustive-deps */
import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import { useContext, useEffect, useState } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"

import { RootState } from "../../../../globalStore/rootreducer"
import {
  TKenkoSindanKirokuData,
  TAnzenKaigiKirokuData,
  TTekiseiSindanKirokuData,
} from "../../../../globalStore/pageStore/zyomuinMaster/kyoikuKensyuJusinData"
import CONSTANT from "../../../../constant"
import { TWijmoCellTemplateContext } from "../../../../type/wijmoComponents"
import dateUtil from "../../../../ts/util/dateUtil"
import SingleFileUploadModal from "./ModalComponent/AttachedSingleFileModal"
import ConfirmModal from "../../../../components/Modal/ConfirmModal"
import { AppDispatch } from "../../../.."
import { BlobContext } from "../ZyomuinMasterRegisterContext"
import { zyomuinMasterActions } from "../../../../globalStore/pageStore/zyomuinMaster/zyomuinMasterStore"
import ContentService from "../../../../service/content/contentService"
import saveAs from "file-saver"
import { setAlerts } from "../../../../globalStore/alertStore"
import { DataChangeAction, DataChangeEventArgs } from "@grapecity/wijmo.grid.immutable"
import { ImmutabilityProvider } from "@grapecity/wijmo.react.grid.immutable"

/**
 * 教育研修受信Accordion
 */
const KyoikuKensyuJusinPane = () => {
  //#region [selector]
  const zyomuinMaster = useSelector((state: RootState) => state.page.zyomuinMaster)
  const disPatch: AppDispatch = useDispatch()
  const { addBlobItem, removeBlobItem } = useContext(BlobContext)
  //#endregion

  //#region [method]

  // 健康診断記録_初期化

  //#region [color2] 健康診断

  /**
   * 健康診断グリッド編集イベント
   * @param s grid
   * @param e
   */
  const on健康診断GridDataChanged = (s: wjrGrid.FlexGrid, e: DataChangeEventArgs) => {
    const castedNewItem = e.newItem as TKenkoSindanKirokuData
    switch (e.action) {
      case DataChangeAction.Change:
        disPatch(
          zyomuinMasterActions.edit健康診断記録テーブル({
            ...castedNewItem,
          })
        )
        break
      default:
        console.log("例外")
    }
  }
  const add健康診断添付ファイル = async (file: File | undefined, fileUrl: string) => {
    if (selected健康診断データ != null) {
      const updateItem: TKenkoSindanKirokuData = {
        ...selected健康診断データ,
        添付ファイル: {
          isNewFile: true,
          ファイル名: file?.name ?? "",
          ファイルURL: fileUrl,
        },
      }
      disPatch(zyomuinMasterActions.edit健康診断記録テーブル(updateItem))

      // Fileをコンテキスト経由で保持
      addBlobItem({ id: updateItem.row_id!, blob: file!, fileUrl: fileUrl })
    }
    setIsShowKenkoSindanFileEditModal(false)
  }
  //#endregion

  // 安全会議記録CollectionView
  const createCollectionViewAnzenKaigiKiroku = (data: TAnzenKaigiKirokuData[]) => new wjcCore.CollectionView(data)
  // 安全会議記録_初期化
  const initGridAnzenKaigiKiroku = (grid: wjcGrid.FlexGrid) => {
    setFlexGridAnzenKaigiKiroku(grid)
  }

  // 適性診断記録CollectionView
  const createCollectionViewTekiseiSindanKiroku = (data: TTekiseiSindanKirokuData[]) =>
    new wjcCore.CollectionView<TTekiseiSindanKirokuData>(data, {
      calculatedFields: {
        実施年齢: (i: TTekiseiSindanKirokuData) => {
          const 実施年齢 = dateUtil.calc年齢(i.実施日, i.生年月日)
          return 実施年齢 == null ? "" : `${実施年齢}歳`
        },
      },
    })
  // 適性診断記録_初期化
  const initGridTekiseiSindanKiroku = (grid: wjcGrid.FlexGrid) => {
    setFlexGridTekiseiSindanKiroku(grid)
  }

  //#endregion

  // #region [state]
  // 健康診断記録
  const [isShowKenkoSindanFileEditModal, setIsShowKenkoSindanFileEditModal] = useState(false)
  const [isShowDeleteKenkoSindanFileConfirmModal, setIsShowDeleteKenkoSindanFileConfirmModal] = useState(false)
  const [selected健康診断データ, setSelected健康診断データ] = useState<TKenkoSindanKirokuData | undefined>()

  // 安全会議記録
  const [itemsSourceAnzenKaigiKiroku, setItemsSourceAnzenKaigiKiroku] = useState<
    wjcCore.CollectionView<TAnzenKaigiKirokuData>
  >(createCollectionViewAnzenKaigiKiroku([...zyomuinMaster.安全会議記録データリスト]))
  const [flexGridAnzenKaigiKiroku, setFlexGridAnzenKaigiKiroku] = useState<wjcGrid.FlexGrid>()

  // 適性診断記録
  const [itemsSourceTekiseiSindanKiroku, setItemsSourceTekiseiSindanKiroku] = useState<
    wjcCore.CollectionView<TTekiseiSindanKirokuData>
  >(createCollectionViewTekiseiSindanKiroku([...zyomuinMaster.適正診断記録データリスト]))
  const [flexGridTekiseiSindanKiroku, setFlexGridTekiseiSindanKiroku] = useState<wjcGrid.FlexGrid>()

  //#endregion

  //#region [effect]
  useEffect(() => {
    setItemsSourceAnzenKaigiKiroku(createCollectionViewAnzenKaigiKiroku([...zyomuinMaster.安全会議記録データリスト]))
    setItemsSourceTekiseiSindanKiroku(
      createCollectionViewTekiseiSindanKiroku([...zyomuinMaster.適正診断記録データリスト])
    )

    flexGridAnzenKaigiKiroku?.refresh()
    flexGridTekiseiSindanKiroku?.refresh()
  }, [zyomuinMaster.安全会議記録データリスト, zyomuinMaster.適正診断記録データリスト])
  //#endregion

  return (
    <>
      <div className="accordion-header">
        健康診断・安全会議・適性診断
        <div className="accordion-description">教育・研修・受診</div>
      </div>
      <div>
        <Row>
          <Col>
            <h5>健康診断記録</h5>
            <Container fluid>
              <Row>
                <Col>
                  <wjrGrid.FlexGrid {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}>
                    <ImmutabilityProvider
                      itemsSource={zyomuinMaster.健康診断記録データリスト}
                      dataChanged={on健康診断GridDataChanged}
                    />
                    <wjrGrid.FlexGridColumn
                      cssClass="read-only-cell"
                      binding="受診日"
                      width={CONSTANT.GRID.COL_SIZE.COL_CALENDAR_INPUT_SIZE}
                      header="受診日">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TKenkoSindanKirokuData>) => {
                          return dateUtil.format(context.item.受診日)
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      cssClass="read-only-cell"
                      binding="医療機関"
                      width={300}
                      header="医療機関"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="添付ファイル名"
                      width={250}
                      header="添付ファイル名"
                      cssClass={"read-only-cell"}
                      cssClassAll={"read-only-cell"}
                      isReadOnly={true}>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TKenkoSindanKirokuData>) => {
                          if (context.item.添付ファイル == null) return ""
                          return (
                            <a
                              href={context.item.添付ファイル.ファイルURL}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(e) => {
                                if (!context.item.添付ファイル?.isNewFile) {
                                  e.preventDefault()
                                  const service = new ContentService()
                                  service
                                    .get(context.item.添付ファイル!.ファイルURL)
                                    .then((blob) => {
                                      saveAs(blob, context.item.添付ファイル?.ファイル名)
                                    })
                                    .catch((err) => disPatch(setAlerts(err)))
                                }
                              }}>
                              {context.item.添付ファイル.ファイル名}
                            </a>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn binding="" width={100} isReadOnly={true} header=" ">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TKenkoSindanKirokuData>) => {
                          if (context.item.row_id == null) return
                          if (context.item.添付ファイル != null) {
                            return (
                              <Button
                                className="btn btn-small btn-primary move-edit-page"
                                variant={"caution"}
                                onClick={() => {
                                  // 選択行データ
                                  setSelected健康診断データ(context.item)
                                  setIsShowDeleteKenkoSindanFileConfirmModal(true)
                                }}>
                                添付削除
                              </Button>
                            )
                          } else {
                            return (
                              <Button
                                className="btn btn-small btn-primary move-edit-page"
                                variant={"working"}
                                onClick={() => {
                                  // 選択行データ
                                  setSelected健康診断データ(context.item)

                                  setIsShowKenkoSindanFileEditModal(true)
                                }}>
                                添付
                              </Button>
                            )
                          }
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                  </wjrGrid.FlexGrid>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>

        <Row>
          <Col>
            <h5>安全会議記録</h5>
            <Container fluid>
              <Row>
                <Col>
                  <wjrGrid.FlexGrid
                    {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                    initialized={initGridAnzenKaigiKiroku}
                    itemsSource={itemsSourceAnzenKaigiKiroku}>
                    <wjrGrid.FlexGridColumn
                      cssClass="read-only-cell"
                      binding="実施日"
                      width={CONSTANT.GRID.COL_SIZE.COL_CALENDAR_INPUT_SIZE}
                      format="d"
                      header="出席日">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TAnzenKaigiKirokuData>) => {
                          return dateUtil.format(context.item.実施日)
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      cssClass="read-only-cell"
                      binding="会議名"
                      width={300}
                      header="会議名"></wjrGrid.FlexGridColumn>
                  </wjrGrid.FlexGrid>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>

        <Row>
          <Col>
            <h5>適性診断記録</h5>
            <Container fluid>
              <Row>
                <Col>
                  <wjrGrid.FlexGrid
                    {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                    initialized={initGridTekiseiSindanKiroku}
                    itemsSource={itemsSourceTekiseiSindanKiroku}>
                    <wjrGrid.FlexGridColumn
                      cssClass="read-only-cell"
                      binding="実施日"
                      width={CONSTANT.GRID.COL_SIZE.COL_CALENDAR_INPUT_SIZE}
                      format="d"
                      header="実施日">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TTekiseiSindanKirokuData>) => {
                          return dateUtil.format(context.item.実施日)
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn binding="実施年齢" width={120} header="実施年齢"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      cssClass="read-only-cell"
                      binding="適性診断種類区分名称1"
                      width={100}
                      header="種類"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      cssClass="read-only-cell"
                      binding="否判定結果"
                      width={300}
                      header="不足点"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      cssClass="read-only-cell"
                      binding="実施機関"
                      width={100}
                      header="実施機関"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      cssClass="read-only-cell"
                      binding="所見"
                      width={500}
                      header="所見"></wjrGrid.FlexGridColumn>
                  </wjrGrid.FlexGrid>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </div>
      <SingleFileUploadModal
        isShow={isShowKenkoSindanFileEditModal}
        setIsShow={setIsShowKenkoSindanFileEditModal}
        addItem={add健康診断添付ファイル}
        fileData={selected健康診断データ?.添付ファイル}
        isShowFileImage={false}
        fileImageUrl=""
        title="健康診断添付ファイル"></SingleFileUploadModal>
      <ConfirmModal
        isShow={isShowDeleteKenkoSindanFileConfirmModal}
        submitHandler={() => {
          if (selected健康診断データ) {
            // Blob解放
            if (selected健康診断データ.添付ファイル != null) removeBlobItem(selected健康診断データ.row_id)

            disPatch(
              zyomuinMasterActions.edit健康診断記録テーブル({
                ...selected健康診断データ,
                添付ファイル: undefined,
              })
            )
          }
          setIsShowDeleteKenkoSindanFileConfirmModal(false)
        }}
        hideHandler={(isCancel) => {
          setIsShowDeleteKenkoSindanFileConfirmModal(false)
        }}>
        <p>添付ファイルを削除しますか？</p>
        <p>※実際の削除は登録ボタン押下時となります</p>
      </ConfirmModal>
    </>
  )
}

export default KyoikuKensyuJusinPane
